import config from '../../config';

export default {
  url: `${config.api.baseURL}/accounts/:accountId/logins`,
  transformer(data) {
    return data;
  }
};
